<div class="container">
    <div class="row">
        <div class="col-sm">
            <div class="card rounded-0">
                <div class="d-lg-none alert alert-warning alert-dismissible" role="alert">
                    <h5 class="alert-heading">
                        <i class="fas fa-mobile"></i> Small Screen!
                    </h5>
                    Some content is hidden on small displays like yours. Please try rotating your device or using a
                    larger screen to
                    see more content.
                </div>
            </div>
        </div>
    </div>
    <div class="row">
        <div class="col-12">
            <div class="card rounded-0 header-text">
                <div class="alert alert-success" role="alert">
                    <p>This page shows the current <span class="italic">FIRST</span> Championship invitation status of
                        regional event teams. Rank is calculated using the process described in Section 12 of the <a
                            href="https://firstfrc.blob.core.windows.net/frc{{season}}/Manual/{{season}}GameManual.pdf"
                            target="_blank">{{season}} <span class="italic">FIRST</span> Robotics Competition Game Manual</a>.
                        <br><br>
                        Teams that qualify for <span class="italic">FIRST</span> Championship via the regional pool will receive email invitations by Wednesday of each week, starting in week 3 for teams qualifying in week 1 and 2 events.
                        <br><br>Partial data will be displayed as events progress and point categories are finalized.
                        Teams who have not yet competed are ranked in team number order.
                    </p>
                </div>
            </div>
        </div>
        <div class="col-12">
            <div class="card rounded-0">
                <mat-form-field style="padding: 10px 0 10px 0;">
                    <mat-label>Search</mat-label>
                    <input matInput (keyup)="applyFilter($event)" placeholder="Ex. team name, team number.." #input>
                    <mat-hint><mat-slide-toggle (change)="toggleQualified($event)">Uninvited Teams Only</mat-slide-toggle></mat-hint>
                </mat-form-field>
            </div>
        </div>
    </div>
    <div class="row">
        <div class="col-sm">
            <div id="mat-elevation-z8">
                <div class="responsive-table">
                    <table mat-table [dataSource]="dataSource" matSort multiTemplateDataRows class="mat-elevation-z8">
                        <!-- Rank Column -->
                        <ng-container matColumnDef="rank">
                            <th mat-header-cell *matHeaderCellDef> Rank </th>
                            <td mat-cell *matCellDef="let element"> {{element.rank}} </td>
                        </ng-container>

                        <!-- Team Name Column -->
                        <ng-container matColumnDef="name">
                            <th mat-header-cell *matHeaderCellDef> <span
                                    class="d-none d-md-block text-center">Team</span> <span
                                    class="d-sm-block d-md-none">Team</span> </th>
                            <td mat-cell *matCellDef="let element">
                                <div class="row text-sm-center">
                                   <div class="col-4 d-none d-md-block">
                                        <img class="mt-1" *ngIf="getAvatar(element.teamNumber)"
                                             [src]="'data:image/png;base64,' + getAvatar(element.teamNumber)" width="40"
                                            height="40" />
                                    </div>
                                    <div class="col-8 text-center text-md-start">
                                        <div class="fw-bold">
                                            <a href="https://frc-events.firstinspires.org/{{season}}/team/{{element.teamNumber}}"
                                                #expanded>{{element.teamNumber}}</a>
                                        </div>
                                        <div class="d-none d-md-block"
                                            style="white-space: nowrap; text-overflow: ellipsis;">
                                            {{element.nameShort}}</div>
                                        <div class="d-sm-block d-md-none" style="text-overflow: ellipsis;">
                                            {{element.nameShort}}</div>
                                    </div>
                                </div>
                            </td>
                        </ng-container>

                        <!-- Total Points Column -->
                        <ng-container matColumnDef="total">
                            <th mat-header-cell *matHeaderCellDef> Regional Points </th>
                            <td mat-cell *matCellDef="let element"> <strong> {{element.totalPoints != null ?
                                    element.totalPoints : "-"}}</strong> </td>
                        </ng-container>

                        <!-- Event 1 Column -->
                        <ng-container matColumnDef="e1">
                            <th mat-header-cell *matHeaderCellDef> Event 1 </th>
                            <td mat-cell *matCellDef="let element"> {{element.regional1Points != null ?
                                element.regional1Points : "-"}} </td>
                        </ng-container>

                        <!-- Event 2 Column -->
                        <ng-container matColumnDef="e2">
                            <th mat-header-cell *matHeaderCellDef> Event 2 </th>
                            <td mat-cell *matCellDef="let element"> {{element.regional2Points != null ?
                                element.regional2Points : ""}} {{element.regional2PointsProjection != null ?
                                element.regional2PointsProjection + "*": ""}} {{element.regional2PointsProjection ==
                                0 && element.regional2Points == 0 ? "-" : ""}}</td>
                        </ng-container>

                        <!-- Qualification Status Column -->
                        <!-- 
                            public enum RegionalRankingStatusTypes
                            {
                                None,
                                QualifiedAtEventByRanking,
                                QualifiedAtEventByAward,
                                QualifiedFromRegionalPool,
                                Prequalified,
                                NotQualified
                            }
                        -->
                        <ng-container matColumnDef="status">
                            <th mat-header-cell *matHeaderCellDef> <i>FIRST</i> Championship </th>
                            <td mat-cell *matCellDef="let element">
                                <span class="badge bg-info"
                                    *ngIf="element.championshipStatus == 'Prequalified'">Pre-Qualified</span>
                                <a href="https://frc-events.firstinspires.org/{{season}}/{{element.qualifiedFirstCmpEventCode}}/awards"
                                    target="_blank" class="badge bg-warning"
                                    *ngIf="element.championshipStatus == 'QualifiedAtEventByAward' && element.qualifiedFirstCmpEventCode != ''"
                                    style="text-decoration: none;">{{element.qualifiedFirstCmpAwardName}} at
                                    {{element.qualifiedFirstCmpEventCode}}</a>
                                <span class="badge bg-success"
                                    *ngIf="element.championshipStatus == 'QualifiedFromRegionalPool' && element.qualifiedFirstCmpEventWeek != 0">Regional
                                    Pool
                                    Week {{element.qualifiedFirstCmpEventWeek}}</span>
                                <span class="badge bg-success"
                                    *ngIf="element.championshipStatus == 'QualifiedAtEventByRanking' && element.qualifiedFirstCmpEventCode != 0">Direct
                                    Qualified at {{element.qualifiedFirstCmpEventCode}}</span>
                                <span class="badge bg-secondary"
                                    *ngIf="element.declinedFirstCmp && element.declinedFirstCmpDate != null">Declined</span>
                            </td>
                        </ng-container>

                        <ng-container matColumnDef="expand">
                            <th mat-header-cell *matHeaderCellDef aria-label="row actions">&nbsp;</th>
                            <td mat-cell *matCellDef="let element">
                                <button mat-icon-button aria-label="expand row"
                                    (click)="(expandedElement = expandedElement === element ? null : element); $event.stopPropagation()">
                                    @if (expandedElement === element) {
                                    <mat-icon>keyboard_arrow_up</mat-icon>
                                    } @else {
                                    <mat-icon>keyboard_arrow_down</mat-icon>
                                    }
                                </button>
                            </td>
                        </ng-container>

                        <!-- Expanded Content Column - The detail row is made up of this one column that spans across all columns -->
                        <ng-container matColumnDef="expandedDetail">
                            <td mat-cell *matCellDef="let element" [attr.colspan]="columnsToDisplayWithExpand.length">
                                <div class="example-element-detail"
                                    [@detailExpand]="element == expandedElement ? 'expanded' : 'collapsed'">
                                    <div style="width: 100%; margin: 5px;" *ngIf="element.regional1Details != null">
                                        <ul class="list-group">
                                            <li class="list-group-item active">
                                                <strong>{{getEventNameByCode(element.regional1Details.tournamentCode)}}
                                                    ({{element.regional1Details.tournamentCode}})</strong>
                                            </li>
                                            <li class="list-group-item">Team Age Points:
                                                <strong>{{element.regional1Details.teamAgePoints}}</strong>
                                            </li>
                                            <li class="list-group-item">Qualification Performance Points:<strong>
                                                    {{element.regional1Details.qualificationPerformancePoints}}</strong>
                                            </li>
                                            <li class="list-group-item">Alliance Selection Points:<strong>
                                                    {{element.regional1Details.allianceSelectionPoints}}</strong></li>
                                            <li class="list-group-item">Playoff Advancement Points:
                                                <strong>{{element.regional1Details.playoffAdvancementPoints}}</strong>
                                            </li>
                                            <li class="list-group-item">Award Points:
                                                <strong>{{element.regional1Details.awardPoints}}</strong>
                                            </li>
                                        </ul>
                                    </div>
                                    <div style="width: 100%; margin: 5px;" *ngIf="element.regional2Details != null">
                                        <ul class="list-group">
                                            <li class="list-group-item active">
                                                <strong>{{getEventNameByCode(element.regional2Details.tournamentCode)}}
                                                    ({{element.regional2Details.tournamentCode}})</strong>
                                            </li>
                                            <li class="list-group-item">Team Age Points:<strong>
                                                    {{element.regional2Details.teamAgePoints}}</strong></li>
                                            <li class="list-group-item">Qualification Performance Points:
                                                <strong>{{element.regional2Details.qualificationPerformancePoints}}</strong>
                                            </li>
                                            <li class="list-group-item">Alliance Selection Points:
                                                <strong>{{element.regional2Details.allianceSelectionPoints}} </strong>
                                            </li>
                                            <li class="list-group-item">Playoff Advancement Points:
                                                <strong>{{element.regional2Details.playoffAdvancementPoints}}</strong>
                                            </li>
                                            <li class="list-group-item">Award Points:
                                                <strong>{{element.regional2Details.awardPoints}}</strong>
                                            </li>
                                        </ul>
                                    </div>
                                    <div style="width: 100%; margin: 5px;" *ngIf="element.tiebreakers != null">
                                        <ul class="list-group">
                                            <li class="list-group-item active"><strong>Tiebreakers</strong></li>
                                            <li class="list-group-item">Max Playoff Advancement Points:<strong>
                                                    {{element.tiebreakers.EventPlayoffPoints}}</strong>
                                            </li>
                                            <li class="list-group-item">Max Alliance Selection Points:<strong>
                                                    {{element.tiebreakers.EventAlliancePoints}}</strong>
                                            </li>
                                            <li class="list-group-item">Max Qualification Performance Points:<strong>
                                                    {{element.tiebreakers.EventQualificationPoints}}</strong>
                                            </li>
                                            <li class="list-group-item">Highest Match Scores:
                                                <strong>{{element.tiebreakers.MatchHighScore1}} <span
                                                        *ngIf="element.tiebreakers.MatchHighScore2 != null">,</span>
                                                    {{element.tiebreakers.MatchHighScore2}} <span
                                                        *ngIf="element.tiebreakers.MatchHighScore3 != null">,</span>
                                                    {{element.tiebreakers.MatchHighScore3}}</strong>
                                            </li>
                                        </ul>
                                    </div>
                                    <div style="width: 100%; margin: 5px;" *ngIf="element.adjustPoints != 0">
                                        <ul class="list-group">
                                            <li class="list-group-item active"><strong>Adjustments</strong></li>
                                            <li class="list-group-item">Points Adjustments:<strong>
                                                {{element.adjustPoints}}</strong>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </td>
                        </ng-container>

                        <tr mat-header-row *matHeaderRowDef="columnsToDisplayWithExpand;sticky: true"
                            style="font-weight: 700"></tr>
                        <tr mat-row *matRowDef="let element; columns: columnsToDisplayWithExpand;"
                            class="example-element-row" [class.example-expanded-row]="expandedElement === element"
                            (click)="expandedElement = expandedElement === element ? null : element">
                        </tr>
                        <tr mat-row *matRowDef="let row; columns: ['expandedDetail']" class="example-detail-row"></tr>

                        <ng-container matColumnDef="footnote">
                            <td mat-footer-cell *matFooterCellDef [colSpan]="columnsToDisplay.length">
                                * For teams who have competed at one event, Event 2 points are awarded based on Event 1
                                performance. See section 12.3.1 of the <a
                                    href="https://firstfrc.blob.core.windows.net/frc{{season}}/Manual/{{season}}GameManual.pdf"
                                    target="_blank">{{ season }} Game Manual</a> for details.
                            </td>
                        </ng-container>
                        <tr mat-footer-row *matFooterRowDef="['footnote']"></tr>
                    </table>
                </div>
                <mat-paginator [pageSizeOptions]="[5, 10, 25, 50, 100]" [pageIndex]="[teamPage]" [pageSize]="25"
                    showFirstLastButtons>
                </mat-paginator>
            </div>
        </div>
    </div>
</div>